/**
 * «Ha entrado por su enlace personal» (`/token`).
 *
 * Lo deja el login por token y lo lee UNA vez el Dashboard: a un empleado B2B con
 * su plan individual en proceso, entrar por el enlace del funnel le abre ese plan;
 * entrar con su contraseña, la vista de empresa (decisión de producto, 15/09/26).
 *
 * Va en `sessionStorage` y no en el estado de la navegación: el Dashboard reescribe
 * la ruta con `replace` al cargar, y ese estado se perdería por el camino.
 */
const TOKEN_LOGIN_INTENT_KEY = 'arca.tokenLogin.openPendingPersonalPlan';

export const markTokenLoginIntent = (): void => {
	try {
		sessionStorage.setItem(TOKEN_LOGIN_INTENT_KEY, 'true');
	} catch {
		// Sin sessionStorage (modo privado estricto) se entra igual: solo no se abre
		// el plan en proceso, que sigue a un clic en el selector.
	}
};

/** Lee la marca y la borra: solo abre el plan en proceso la primera vez. */
export const consumeTokenLoginIntent = (): boolean => {
	try {
		const marked = sessionStorage.getItem(TOKEN_LOGIN_INTENT_KEY) === 'true';
		sessionStorage.removeItem(TOKEN_LOGIN_INTENT_KEY);
		return marked;
	} catch {
		return false;
	}
};
